import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";
import { adminFetch } from "../utils/adminAuth";

/*
  "Advertise" management tool.
  Lists submissions from the site's "Advertise Your Business" form
  (Navbar), stored in advertisement_enquiries.
*/
export default function AdminAdvertisement() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        adminFetch(`${API_BASE}/api/get_advertisements.php`)
            .then((r) => r.json())
            .then((data) => { if (data.success) setRows(data.ads); })
            .finally(() => setLoading(false));
    };

    useEffect(load, []);

    const goalLabel = (goal) => {
        const map = {
            more_calls: "More Calls",
            more_leads: "More Leads",
            brand_awareness: "Brand Awareness",
            website_traffic: "Website Traffic",
        };
        return goal ? (map[goal] || goal) : "—";
    };

    return (
        <div>
            <h5 className="fw-bold mb-1">Advertise — Enquiries</h5>
            <p className="text-secondary small mb-3">
                Submissions from the site's "Advertise Your Business" form.
            </p>

            <div className="card shadow-sm">
                <div className="card-body p-0">
                    {loading ? (
                        <div className="p-3">Loading...</div>
                    ) : rows.length === 0 ? (
                        <div className="p-3 text-secondary">No enquiries yet.</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-sm mb-0 align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th>Business</th>
                                        <th>Contact</th>
                                        <th>City</th>
                                        <th>Category</th>
                                        <th>Budget</th>
                                        <th>Website</th>
                                        <th>Goal</th>
                                        <th>Source</th>
                                        <th>Captured</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((r) => (
                                        <tr key={r.id}>
                                            <td className="fw-semibold">{r.business_name}</td>
                                            <td className="small">
                                                {r.contact_person}<br />
                                                {r.mobile}<br />
                                                <span className="text-secondary">{r.email}</span>
                                            </td>
                                            <td className="small">{r.city}</td>
                                            <td className="small">{r.category || "—"}</td>
                                            <td className="small">{r.budget_range || "—"}</td>
                                            <td className="small">
                                                {r.website
                                                    ? <a href={r.website} target="_blank" rel="noopener noreferrer">{r.website}</a>
                                                    : "—"}
                                            </td>
                                            <td><span className="badge bg-info text-dark">{goalLabel(r.ad_goal)}</span></td>
                                            <td><span className="badge bg-secondary">{r.source}</span></td>
                                            <td className="text-secondary small">{r.created_at}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}